import { render, staticRenderFns } from "./LogoInstagramSvg.vue?vue&type=template&id=e3d33cde"
import script from "./LogoInstagramSvg.vue?vue&type=script&lang=js"
export * from "./LogoInstagramSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports